"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metertest = void 0;
exports.metertest = {
    "addresses": {
        "ProxyAdmin": "0x76A866328b857B6db868C6D087dE2249A0a713ad",
        "SumerTimelockController": "0xC5e73C231C63A10237F01B58948966Bec19e86d2",
        "Multicall2": "0xcA11bde05977b3631167028862bE2a173976CA11",
        "Sumer": "0x264b7316b535515db9759a77dc4041c0c2263527",
        "CompoundLens": "0x2F141295B1bCa631441b6265A627aBC27a9FB7D9",
        "FeedPriceOracle": "0xb37DAdCdAE2Ba0921D5472356c9b378DdC8e20C1",
        "CompLogic": "0xF01883F9846117795a1de3484aBE40640BBaAA56",
        "RedemptionManager": "0xE353980ca3de5d6f98B8641AaD92b01C8effdD39",
        "Timelock": "0xCAb37e1C3e52016cA6a89bb5604631d95144E7c1",
        "Comptroller": "0x512eb15F3Ca5e85E6545fEbaE9c3cFC481Ae959A",
        "sdrMTR": "0x70C638683384BD824af6D98CbC51184A2b66f95F",
        "MTR": "0x0000000000000000000000000000000000000000",
        "CErc20": "0x212b632127a2F2E637D67A7416393644fD7aed4D",
        "suErc20": "0xC7689B28f80dE542ae986719d5E2f7F0d1806A34",
        "WstMTRGAdapter": "0xB94F5f9d1910a2621e08EA30D8040cA980b29220",
        "JumpRate#1": "0xBe7DAF7117592669337232BDd8f75Aa83628bbcE",
        "JumpRate#2": "0xe19dC83892312A5BB2B561662e930394c348156d",
        "ZeroRate": "0x8d605B1F768Db4D936067c22dB6D1B9674d1FB5A",
        "FixedInterestRateModel": "0x1b2B35628d98AF3789294B9D8405dBbb2825ad09",
        "sdrUSDX": "0x8138530487abaCab0aDe79664451cBd7ee8F6225",
        "USDX": "0x4b770584943e2b7788D2C6307d0B95E4Ab215445",
        "sdrUSDC": "0xD30511008f7a2eA14610E736d7d425bFFBbA7085",
        "USDC": "0x2b27f5f7f2867ad9d2b7065f81e985c1bd1b7274",
        "sdrUSDT": "0x2F8C2edb76F027AcdA1C54E14EDABCE95277Cc1F",
        "USDT": "0x2398633bee182cad2d0388b41735fd9fb742098d",
        "sdrMTRG": "0x8bC382b72F892466395faaC3Ab48C9ba368D6afA",
        "MTRG": "0x8a419ef4941355476cf04933e90bf3bbf2f73814",
        "sdrwstMTRG": "0x5531a60D8f199907780C7af94a31F8A8281E8321",
        "wstMTRG": "0x871497Eb8596d2cBdBE5bb23D552D35bFfbb8CF5",
        "sdrETH": "0x6680B3873AE242714e8801b336ad45cE742c5025",
        "ETH": "0xe8876830e7cc85dae8ce31b0802313caf856886f",
        "sdrBTC": "0x2bBCF2769292C06AFc39D82E2aF107c1635D16DE",
        "BTC": "0x7EB9e0Df1C6E6f1E9d3d1EdA09fcF688FE7A710c",
        "sdrsuUSD": "0xEe015F1adf3D6669d0FeBABf7132572DDF806F9b",
        "suUSD": "0x96159A91291c92dF19983E53E14726b1de3f7c49",
        "sdrsuETH": "0x9525e818061FC0b736a22A289487d7c8a8EcCb31",
        "suETH": "0x85FEA956FD041e98433caB1b6041C6161224AB4d",
        "sdrsuBTC": "0x061556C88E4e16c79bA5Ca0fC16339945F602F7a",
        "suBTC": "0x46BD5E81162c85056ED8cA2aa16934481Ba99Bd3"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDX",
            "ctokenAddr": "0x8138530487abaCab0aDe79664451cBd7ee8F6225",
            "underlySym": "USDX",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x4b770584943e2b7788D2C6307d0B95E4Ab215445",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0xD30511008f7a2eA14610E736d7d425bFFBbA7085",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x2b27f5f7f2867ad9d2b7065f81e985c1bd1b7274",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "0x2F8C2edb76F027AcdA1C54E14EDABCE95277Cc1F",
            "underlySym": "USDT",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x2398633bee182cad2d0388b41735fd9fb742098d",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrMTRG",
            "ctokenAddr": "0x8bC382b72F892466395faaC3Ab48C9ba368D6afA",
            "underlySym": "MTRG",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8a419ef4941355476cf04933e90bf3bbf2f73814",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrwstMTRG",
            "ctokenAddr": "0x5531a60D8f199907780C7af94a31F8A8281E8321",
            "underlySym": "wstMTRG",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x871497Eb8596d2cBdBE5bb23D552D35bFfbb8CF5",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrETH",
            "ctokenAddr": "0x6680B3873AE242714e8801b336ad45cE742c5025",
            "underlySym": "ETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe8876830e7cc85dae8ce31b0802313caf856886f",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrBTC",
            "ctokenAddr": "0x2bBCF2769292C06AFc39D82E2aF107c1635D16DE",
            "underlySym": "BTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x7EB9e0Df1C6E6f1E9d3d1EdA09fcF688FE7A710c",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0xEe015F1adf3D6669d0FeBABf7132572DDF806F9b",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": true,
            "underlyAddr": "0x96159A91291c92dF19983E53E14726b1de3f7c49",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuETH",
            "ctokenAddr": "0x9525e818061FC0b736a22A289487d7c8a8EcCb31",
            "underlySym": "suETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": true,
            "underlyAddr": "0x85FEA956FD041e98433caB1b6041C6161224AB4d",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0x061556C88E4e16c79bA5Ca0fC16339945F602F7a",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": true,
            "underlyAddr": "0x46BD5E81162c85056ED8cA2aa16934481Ba99Bd3",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrMTR",
            "ctokenAddr": "0x70C638683384BD824af6D98CbC51184A2b66f95F",
            "underlySym": "MTR",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#1",
            "contract": "JumpRateModelV2",
            "address": "0xBe7DAF7117592669337232BDd8f75Aa83628bbcE",
            "tokens": [
                "MTR",
                "USDT",
                "ETH",
                "BTC",
                "MTR"
            ],
            "baseRatePerYear": "0.02",
            "multiplierPerYear": "0.12",
            "jumpMultiplierPerYear": "1",
            "kink": "0.75"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0x8d605B1F768Db4D936067c22dB6D1B9674d1FB5A",
            "tokens": [
                "USDX",
                "suUSD",
                "suETH",
                "suBTC"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        },
        {
            "name": "JumpRate#2",
            "contract": "JumpRateModelV2",
            "address": "0xe19dC83892312A5BB2B561662e930394c348156d",
            "tokens": [
                "USDC",
                "MTRG",
                "wstMTRG"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.06",
            "jumpMultiplierPerYear": "1.5",
            "kink": "0.45"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=metertest.js.map